/** Available member types to filter from the backend. */
const memberTypes = {
  MEMBERS: 'members',
  AI_ASSISTANTS: 'ai_assistants',
};
Object.freeze(memberTypes);

/** Functions to filter the members from the list of all members. */
const memberFilterMethods = {
  [memberTypes.MEMBERS]: m => m.ai_assistant !== true,
  [memberTypes.AI_ASSISTANTS]: m => m.ai_assistant === true,
};

export {
  memberTypes,
  memberFilterMethods,
};
